(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('role', {
                parent: 'entity',
                url: '/role?page&sort&search',
                ncyBreadcrumb: {
                    label: 'Roles'
                },
                data: {
                    authorities: [],
                    pageTitle: 'Roles'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/auth-item/roles.html',
                        controller: 'AuthItemController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    entityType: ['AUTH_ITEM_TYPE', function (AUTH_ITEM_TYPE) {
                        return {
                            title: 'Roles',
                            entityClassHumanized: 'Role',
                            entityStateName: 'role',
                            type: AUTH_ITEM_TYPE.TYPE_ROLE
                        };
                    }],
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MANAGE_ROLE_RESOURCE_AND_ACTIONS];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MANAGE_ROLE_RESOURCE_AND_ACTIONS, access);
                }]
            })
            .state('role.new', {
                parent: 'role',
                url: '/new',
                ncyBreadcrumb: {
                    label: 'New Role'
                },
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MANAGE_ROLE_RESOURCE_AND_ACTIONS, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/auth-item/role-dialog.html',
                            controller: 'RoleDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'xl',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['CoreService', function (CoreService) {
                                    return {
                                        id: null,
                                        name: null,
                                        type: null,
                                        description: null,
                                        data: null,
                                        children: [],
                                        corporation: CoreService.getCorporation()
                                    };
                                }]
                            }
                        }).result.then(function () {
                            $state.go('role', null, {reload: 'role'});
                        }, function () {
                            $state.go('role');
                        });
                    }
                }]
            })
            .state('role.edit', {
                parent: 'role',
                url: '/{id}/edit',
                ncyBreadcrumb: {
                    label: 'Edit Role'
                },
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MANAGE_ROLE_RESOURCE_AND_ACTIONS, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/auth-item/role-dialog.html',
                            controller: 'RoleDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'xl',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['AuthItem', function (AuthItem) {
                                    return AuthItem.getRole({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('role', null, {reload: 'role'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            })
            .state('role.delete', {
                parent: 'role',
                url: '/{id}/delete',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MANAGE_ROLE_RESOURCE_AND_ACTIONS, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/auth-item/auth-item-delete-dialog.html',
                            controller: 'AuthItemDeleteController',
                            controllerAs: 'vm',
                            size: 'md',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['AuthItem', function (AuthItem) {
                                    return AuthItem.get({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('role', null, {reload: 'role'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            });
    }
})();
